import {AnoBase} from './ano-base.model';
import { Moment } from 'moment';

export class Rda {

  id: number;
  anoBase: AnoBase;
  enviado: boolean;
  dataAlteracao: Moment;

  constructor(init?: Partial<Rda>) {
    Object.assign(this, init);
  }
}
